import { render } from "./RelationshipUnlinkDialog.vue?vue&type=template&id=d585ed32&ts=true"
import script from "./RelationshipUnlinkDialog.vue?vue&type=script&lang=ts"
export * from "./RelationshipUnlinkDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__